import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

// Components
import CircularProgress from "components/master/CircularProgress";

// Scss
import "./ImpactsTracking.scss";

// Icons & Images
import Bookmark from "assets/icons/bookmark.svg";
import ThumbsUp from "assets/icons/thumb-up.svg";
import Measurement from "assets/icons/measurement.svg";
import QuestionMark from "assets/icons/question-mark.svg";
import ImpactSummary from "assets/icons/impact-summary.svg";
import Rag from "assets/icons/rag.svg";
import UserIcon from "assets/icons/user-icon.svg";
import CalendarIcon from "assets/icons/calendar-icon.svg";
import BaselineIcon from "assets/icons/baseline-icon.svg";
import TargetValueIcon from "assets/icons/target-value-icon.svg";
import ActualValueIcon from "assets/icons/actual-value-icon.svg";
import MeasurementDatesIcon from "assets/icons/measurement-dates.svg";
import EmployeeRetention from "assets/icons/employee-retention.svg";
import PriorityIcon from "assets/icons/priority-icon.svg";
import Change from "assets/icons/change.svg";
import ReasonForChange from "assets/icons/reason-for-change.svg";
import ActionsRequiredIcon from "assets/icons/actions-required.svg";
import Calenders from "assets/icons/calenders.svg";
import ProjectStatus from "assets/icons/project-status.svg";
import GreenBg from "assets/images/circular-green-bg.svg";
import BlueBg from "assets/images/circular-blue-bg.svg";
import YellowBg from "assets/images/circular-yellow-bg.svg";
import ChangeArrowGreen from "assets/icons/change-arrowgreen.svg";
import ChangeArrowAmber from "assets/icons/change-arrowamber.svg";
import ChangeArrowRed from "assets/icons/change-arrowred.svg";
import MODLoader from "assets/images/mod-loader.gif";

// Variables & Constants
const apiUri = "https://arrowmod.dig-x.co.in";

function getOnlyDate(dateTime) {
  let date = new Date(dateTime);
  let year = date.getFullYear();
  let month =
    date.getMonth().toString().length > 1
      ? date.getMonth()
      : "0" + date.getMonth();

  let day =
    date.getDate().toString().length > 1
      ? date.getDate()
      : "0" + date.getDate();

  month = parseInt(month) + 1;
  let dateWithoutTime = day + "-" + month + "-" + year;
  return dateWithoutTime;
}

function ImpactsTracking() {
  const { state } = useLocation();
  let [isLoader, setIsLoader] = useState(false);
  let [impactDetails, setImpactDetails] = useState([]);
  let [projectsStrategicObjectives, setProjectsStrategicObjectives] = useState(
    []
  );


  function generateUUID() {
    return uuidv4(); // ⇨ '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d'
  }

  useEffect(() => {
    async function fetchData() {
      setIsLoader(true);
      const response = await axios.get(
        `${apiUri}/api/ImpactDetails?ImpactID=${state.selected}`
      );
      setImpactDetails(response.data);
      setIsLoader(false);
    }
    fetchData();
  }, [state]);

  useEffect(() => {
    async function fetchData() {
      setIsLoader(true);
      const response = await axios.get(
        `${apiUri}/api/ProjectsByImpact?ImpactTitle=${state.title}`
      );
      setProjectsStrategicObjectives(response.data);
      setIsLoader(false);
    }
    fetchData();
  }, [state]);

  return (
    <>
      {isLoader && (
        <div className="loader-container">
          <img src={MODLoader} alt="#" />
        </div>
      )}

      <>
        {impactDetails.length > 0 && (
          <>
            <section className="ref-benefit">
              <div className="tile ref">
                <div className="ref-mark">
                  <div className="circular-icon-container">
                    <img src={Bookmark} alt="#" />
                  </div>
                  <div className="title">Impact Priority</div>
                </div>
                <div className="ref-alpha">
                  <div className="alphabet low">
                    {impactDetails[0].PRIORTY === 0 ||
                    impactDetails[0].PRIORTY === 1
                      ? "VERY LOW"
                      : impactDetails[0].PRIORTY === 2
                      ? "LOW"
                      : impactDetails[0].PRIORTY === 3
                      ? "MEDIUM"
                      : impactDetails[0].PRIORTY === 4
                      ? "HiGH"
                      : impactDetails[0].PRIORTY >= 5
                      ? "VERY HIGH"
                      : ""}
                  </div>
                </div>
              </div>
              <div className="tile benefit">
                <div className="ref-mark">
                  <div className="circular-icon-container">
                    <img src={ThumbsUp} alt="#" />
                  </div>
                  <div className="title">Strategic Objective</div>
                </div>
                <div className="ref-alpha so">
                  <div className="value">
                    <p>{state.SO}</p>
                  </div>
                </div>
              </div>
            </section>
            <section className="measurements">
              <div className="tile measurement-unit">
                <div className="ref-mark">
                  <div className="circular-icon-container">
                    <img src={Measurement} alt="#" />
                  </div>
                  <div className="title">
                    <span>Measurement & Unit of measurement</span>
                  </div>
                </div>
                <div className="ref-alpha so">
                  <div className="value">
                    <p>
                      {impactDetails[0].MEASUREMENTDESCRIPTION == null
                        ? "NA"
                        : impactDetails[0].MEASUREMENTDESCRIPTION}
                    </p>
                  </div>
                </div>
              </div>
              <div className="tile measurement-question">
                <div className="ref-mark">
                  <div className="circular-icon-container">
                    <img src={QuestionMark} alt="#" />
                  </div>
                  <div className="title">
                    <span>Measurement Question</span>
                  </div>
                </div>
                <div className="ref-alpha">
                  <div className="value">
                    <p>
                      {impactDetails[0].MEASUREMENTQUESTION == null
                        ? "NA"
                        : impactDetails[0].MEASUREMENTQUESTION}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="impact-summary">
              <div className="tile">
                <div className="impact-summary-head">
                  <div className="lines gap-right">
                    <hr />
                  </div>
                  <span>
                    <img src={ImpactSummary} alt="#" />
                    Impact Summary
                  </span>
                  <div className="lines gap-left">
                    <hr />
                  </div>
                </div>
                <div className="summary-detail">
                  <div className="detail-container">
                    <div className="icon-value">
                      <span>
                        <img src={Rag} alt="#" />
                        Current RAG Status
                      </span>
                    </div>
                    <div className="stick-end">
                      <span
                        className={`
                      tag
                      ${
                        impactDetails[0].CURRENTRAGSTATUS === "Low"
                          ? "green"
                          : impactDetails[0].CURRENTRAGSTATUS === "Medium"
                          ? "amber"
                          : "red"
                      }
                    `}
                      ></span>
                    </div>
                  </div>
                  <div className="detail-container">
                    <div className="icon-value">
                      <span>
                        <img src={UserIcon} alt="#" />
                        Director Owner
                      </span>
                    </div>
                    <div className="stick-end">
                      <span>{impactDetails[0].DIRECTOROWNER}</span>
                    </div>
                  </div>
                  <div className="detail-container">
                    <div className="icon-value">
                      <span>
                        <img src={CalendarIcon} alt="#" />
                        End date to be realized
                      </span>
                    </div>
                    <div className="stick-end">
                      <span>
                        {getOnlyDate(impactDetails[0].ENDDATETOBEREALIZE)}
                      </span>
                    </div>
                  </div>
                  <div className="detail-container">
                    <div className="icon-value">
                      <span>
                        <img src={UserIcon} alt="#" />
                        Operational Owner
                      </span>
                    </div>
                    <div className="stick-end">
                      <span>{impactDetails[0].OPERATIONALOWNER}</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Impact Section Section */}
            <>
              <section>
                <div className="section-header">
                  <div className="lines gap-right">
                    <hr />
                  </div>
                  <div className="header-info">
                    <div className="icon-container">
                      <img src={ImpactSummary} alt="#" />
                    </div>
                    <div className="info-container">
                      <span>MEASUREMENT OF IMPACT</span>
                      <span>({impactDetails[0].IMPACTNAME})</span>
                    </div>
                  </div>
                  <div className="lines gap-left">
                    <hr />
                  </div>
                </div>
              </section>
              <section className="charts-and-data">
                <div className="employee-status mr">
                  <div
                    className={`
                  icon-holder 
                  ${
                      impactDetails[0].CHANGE >= -5
                      ? "green"
                      : impactDetails[0].CHANGE < -5 && impactDetails[0].CHANGE >= -10
                      ? "amber"
                      : "red"
                  }
                `}
                  >
                    <img src={EmployeeRetention} alt="#" />
                  </div>

                  <span>{impactDetails[0].IMPACTNAME}</span>

                  <div className="status-holder">
                    <span className="status-label">Status</span>
                    <div
                      className={`
                    status
                    ${
                      impactDetails[0].CHANGE >= -5
                      ? "green"
                      : impactDetails[0].CHANGE < -5 && impactDetails[0].CHANGE >= -10
                      ? "amber"
                      : "red"
                    }
                  `}
                    ></div>
                  </div>
                </div>
                <div className="chart-container mr baseline-value">
                  <img src={BaselineIcon} alt="#" />
                  <CircularProgress
                    data={{
                      pbId: `pb-${generateUUID()}`,
                      vcId: `vc-${generateUUID()}`,
                      img: GreenBg,
                      value: impactDetails[0].TARGETVALUE,
                    }}
                  />
                  <span>Baseline Value</span>
                </div>
                <div className="chart-container mr target-value">
                  <img src={TargetValueIcon} alt="#" />
                  <CircularProgress
                    data={{
                      pbId: `pb-${generateUUID()}`,
                      vcId: `vc-${generateUUID()}`,
                      img: BlueBg,
                      value: impactDetails[0].TARGETVALUE,
                    }}
                  />
                  <span>Target Value</span>
                </div>
                <div className="chart-container mr actual-value">
                  <img src={ActualValueIcon} alt="#" />
                  <CircularProgress
                    data={{
                      pbId: `pb-${generateUUID()}`,
                      vcId: `vc-${generateUUID()}`,
                      img: YellowBg,
                      value: impactDetails[0].ACHIEVED,
                    }}
                  />
                  <span>Actual Value</span>
                </div>
                <div className="data-container mr">
                  <div className="top-float">
                    <span>
                      <img src={MeasurementDatesIcon} alt="#" />
                      Measurement Dates
                    </span>
                    <div className="dates">
                      <span>Baseline</span>
                      <div className="seperator">
                        <hr />
                      </div>
                      <span>
                        {impactDetails[0].BASELINEDATE != null
                          ? getOnlyDate(impactDetails[0].BASELINEDATE)
                          : "NA"}
                      </span>
                    </div>
                    <div className="dates">
                      <span>Previous</span>
                      <div className="seperator">
                        <hr />
                      </div>
                      <span>
                        {impactDetails[0].PREVIOUSDATE != null
                          ? getOnlyDate(impactDetails[0].PREVIOUSDATE)
                          : "NA"}
                      </span>
                    </div>
                    <div className="dates">
                      <span>Current</span>
                      <div className="seperator">
                        <hr />
                      </div>
                      <span>
                        {impactDetails[0].CURRENTDATE != null
                          ? getOnlyDate(impactDetails[0].CURRENTDATE)
                          : "NA"}
                      </span>
                    </div>
                  </div>
                  <div className="done-by">
                    <span>Measurement To Be Done By</span>
                    <span>{impactDetails[0].MEASUREMENTTO}</span>
                  </div>
                </div>
              </section>
              <section className="meta-data">
                <div className="date-container">
                  <div className="top-float sep">
                    <span>
                      <img src={Calenders} alt="#" />
                      <div>
                        <span>START DATE</span>
                        <span className="date">
                          {impactDetails[0].STARTDATE != null
                            ? getOnlyDate(impactDetails[0].STARTDATE)
                            : "NA"}
                        </span>
                      </div>
                    </span>
                  </div>
                  <div className="bottom-float sh-none">
                    <span>
                      <img src={Calenders} alt="#" />
                      <div>
                        <span>END DATE</span>
                        <span className="date">
                          {impactDetails[0].ENDDATE != null
                            ? getOnlyDate(impactDetails[0].ENDDATE)
                            : "NA"}
                        </span>
                      </div>
                    </span>
                  </div>
                </div>
                <div className="basic-tile mr">
                  <img src={PriorityIcon} alt="#" />
                  <span>Priority</span>
                  <span
                    className={`
                    pnumber
                    ${
                      impactDetails[0].PRIORTY === 0 ||
                      impactDetails[0].PRIORTY === 1
                        ? "verylow"
                        : impactDetails[0].PRIORTY === 2
                        ? "low"
                        : impactDetails[0].PRIORTY === 3
                        ? "medium"
                        : impactDetails[0].PRIORTY === 4
                        ? "high"
                        : impactDetails[0].PRIORTY === 5
                        ? "veryhigh"
                        : ""
                    }
                  `}
                  >
                    {impactDetails[0].PRIORTY}
                    <span className="outof">/ 5</span>
                  </span>
                  <div className="color-meanings">
                    <div className="color-codes">
                      <div className="circle verylow"></div>
                      <span className="verylow">VERY LOW</span>
                    </div>
                    <div className="color-codes">
                      <div className="circle low"></div>
                      <span className="low">LOW</span>
                    </div>
                    <div className="color-codes">
                      <div className="circle medium"></div>
                      <span className="medium">MEDIUM</span>
                    </div>
                    <div className="color-codes">
                      <div className="circle high"></div>
                      <span className="high">HIGH</span>
                    </div>
                    <div className="color-codes">
                      <div className="circle veryhigh"></div>
                      <span className="veryhigh">VERY HIGH</span>
                    </div>
                  </div>
                </div>
                <div className="basic-tile mr">
                  <div
                    className={`
                    icon-holder 
                    ${
                      impactDetails[0].CHANGE >= -5
                      ? "green"
                      :  impactDetails[0].CHANGE < -5 &&  impactDetails[0].CHANGE >= -10
                      ? "amber"
                      : "red"
                    }
                  `}
                  >
                    <img src={Change} alt="#" />
                  </div>
                  <span>Change</span>
                  <div className="change-percentage">
                    <img
                      src={`
                        ${
                          impactDetails[0].CHANGE >= -5 ? ChangeArrowGreen : 
                          impactDetails[0].CHANGE < -5 && impactDetails[0].CHANGE >= -10 ? ChangeArrowAmber : ChangeArrowRed
                        }
                      `}
                      alt="#"
                      className={`
                      ${
                        impactDetails[0].CHANGE === 0 ? '' : 
                        impactDetails[0].CHANGE > 0 ? 'rotate-up' : 'rotate-down' 
                      }
                    `}
                    />
                    <span
                      className={`
                      ${
                        impactDetails[0].CHANGE >= -5 ? 'green-text' : 
                        impactDetails[0].CHANGE < -5 && impactDetails[0].CHANGE >= -10 ? 'amber-text' : 'red-text'
                      }
                    `}
                    >
                      {impactDetails[0].CHANGE}%
                    </span>
                  </div>
                  <div
                    className={`
                      p-bar
                      ${
                        impactDetails[0].CHANGE >= -5 ? 'green-blur' : 
                        impactDetails[0].CHANGE < -5 && impactDetails[0].CHANGE >= -10 ? 'amber-blur' : 'red-blur'
                      }
                    `}
                  >
                    <div
                      className={`
                    p-bar-percentage
                    ${
                      impactDetails[0].CHANGE >= -5 ? 'green' : 
                      impactDetails[0].CHANGE < -5 && impactDetails[0].CHANGE >= -10 ? 'amber' : 'red'
                    }
                  `}
                      style={{ width: impactDetails[0].CHANGE }}
                    ></div>
                  </div>
                </div>
                <div className="stretch-tile mr">
                  <img src={ReasonForChange} alt="#" />
                  <span>REASON FOR CHANGE</span>
                  <div className="typography">
                    <p>
                      {impactDetails[0].REASONFORCHANGE == null
                        ? "Not Applicable"
                        : impactDetails[0].REASONFORCHANGE}
                    </p>
                  </div>
                </div>
                <div className="stretch-tile mr">
                  <img src={ActionsRequiredIcon} alt="#" />
                  <span>ACTIONS REQUIRED TO REALISE THE BENEFIT</span>
                  <div className="typography">
                    <p>
                      {impactDetails[0].ACTIONREQUIRED == null
                        ? "Not Applicable"
                        : impactDetails[0].ACTIONREQUIRED}
                    </p>
                  </div>
                </div>
              </section>
            </>
            {/* Impact Section End*/}
          </>
        )}

        {projectsStrategicObjectives.length > 0
          ? ProjectSection(projectsStrategicObjectives)
          : "No Projects Found"}
      </>
    </>
  );
}
function ProjectSection(projectsStrategicObjectives) {
  function getOnlyDate(dateTime) {
    let date = new Date(dateTime);
    let year = date.getFullYear();
    let month =
      date.getMonth().toString().length > 1
        ? date.getMonth()
        : "0" + date.getMonth();

    let day =
      date.getDate().toString().length > 1
        ? date.getDate()
        : "0" + date.getDate();

    month = parseInt(month) + 1;
    let dateWithoutTime = day + "-" + month + "-" + year;
    return dateWithoutTime;
  }
  return (
    <section className="project-status">
      <div className="section-inner-header">
        <img src={ProjectStatus} alt="#" />
        <span className="head-title">PROJECT STATUS</span>
      </div>
      <table>
        <thead>
          <tr>
            <th>Project ID</th>
            <th>Project Name</th>
            <th>Implementing Agent</th>
            <th>Duration</th>
            <th>Start Date</th>
            <th>Finish Date</th>
            <th>CPI</th>
            <th>SPI</th>
            <th>% Completed</th>
            <th>Overall Status</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {projectsStrategicObjectives.map((item) => {
            return (
              <tr>
                <td>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="http://kpmg.dig-x.co.in/#/project-ar?id=f3983d67-6574-eb11-8af0-005056921d78"
                  >
                    {item.PROJECTID}
                  </a>
                </td>
                <td>{item.PROJECTNAME}</td>
                <td>{item.IMPLEMENTINGAGENT != null ? item.IMPLEMENTINGAGENT : 'NA'}</td>
                <td>{item.DURATION}</td>
                <td>{getOnlyDate(item.STARTDATE)}</td>
                <td>{getOnlyDate(item.ENDDATE)}</td>
                <td>{item.CPI}</td>
                <td>{item.SPI}</td>
                <td>{item.COMPLETED}%</td>
                <td className={`
                  ${
                    item.OVERALLSTATUS === 'On Track' ? 'on-track' :
                    item.OVERALLSTATUS === 'Moderate Delay' ? 'moderate-delay': 
                    item.OVERALLSTATUS === 'Significant Delay' ? 'significant-delay':  'not-started'
                  }
                
                `}>{item.OVERALLSTATUS}</td>
                <td>{item.REMARKS != null ? item.REMARKS : 'NA'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
}

export default ImpactsTracking;
